import * as React from "react";
const SvgMinimax = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#Minimax_svg__a)",
  d: "M16.278 2c1.156 0 2.093.927 2.093 2.07v12.501a.74.74 0 0 0 .744.709.74.74 0 0 0 .743-.709V9.099a2.06 2.06 0 0 1 2.071-2.049A2.06 2.06 0 0 1 24 9.1v6.561a.65.65 0 0 1-.652.645.65.65 0 0 1-.653-.645V9.1a.763.763 0 0 0-1.058-.702.76.76 0 0 0-.474.702v7.472a2.036 2.036 0 0 1-2.048 2.026 2.04 2.04 0 0 1-2.048-2.026v-12.5a.785.785 0 0 0-.788-.753.785.785 0 0 0-.789.752l-.001 15.904A2.037 2.037 0 0 1 13.441 22a2.04 2.04 0 0 1-2.048-2.026V18.04c0-.356.292-.645.652-.645s.652.289.652.645v1.934c0 .263.142.506.372.638a.753.753 0 0 0 1.016-.269c.065-.112.1-.24.1-.369V4.07c0-1.143.937-2.07 2.093-2.07m-5.674 0c1.156 0 2.093.927 2.093 2.07v11.523a.65.65 0 0 1-.652.645.647.647 0 0 1-.652-.645V4.07a.785.785 0 0 0-.789-.78.785.785 0 0 0-.789.78v14.013a2.06 2.06 0 0 1-2.07 2.048 2.06 2.06 0 0 1-2.071-2.048V9.1a.76.76 0 0 0-.766-.758.76.76 0 0 0-.766.758v3.8a2.06 2.06 0 0 1-2.071 2.049A2.06 2.06 0 0 1 0 12.9v-1.378c0-.357.292-.646.652-.646s.653.29.653.646V12.9c0 .418.343.757.766.757a.76.76 0 0 0 .766-.757V9.099a2.06 2.06 0 0 1 2.07-2.048 2.06 2.06 0 0 1 2.071 2.048v8.984c0 .419.343.758.767.758a.76.76 0 0 0 .766-.758V4.07c0-1.143.937-2.07 2.093-2.07"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Minimax_svg__a",
  x1: 0,
  x2: 24.044,
  y1: 12.011,
  y2: 12.011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2167E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE603C"
}))));
export default SvgMinimax;
//# sourceMappingURL=Minimax.js.map